<template>
  <div>
    <div class="modal fade" id="cadastrarUsuario" tabindex="-1">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header text-center">
            <h4 class="modal-title w-300 font-weight-bold">Cadastrar Usuário</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="row">
                <!-- Etapa D: origem da senha -->
                <div class="col-sm-12 col-md-12 col-lg-12 mb-2">
                    <label for="strorigem">Autenticação<span class="required-label">*</span></label>
                    <select id="strorigem" class="browser-default custom-select" v-model="usuario.strorigem">
                        <option value="ad">Rede (senha do Windows / AD)</option>
                        <option value="local">Local (senha do eVoto)</option>
                    </select>
                    <small class="form-text text-muted" v-if="usuario.strorigem == 'ad'">
                        O usuário entra com o login e a senha da rede. O login deve ser igual ao do Windows (ex.: nome.sobrenome).
                    </small>
                    <small class="form-text text-muted" v-else-if="adHabilitado">
                        Com a autenticação pela rede habilitada, contas locais são aceitas somente para Administrador (contingência).
                    </small>
                </div>

                <!-- Busca no AD (preenche login, nome e e-mail) -->
                <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="usuario.strorigem == 'ad' && adHabilitado">
                    <label for="buscaAD">Buscar no AD (login ou nome)</label>
                    <div class="input-group">
                        <input type="text" id="buscaAD" class="form-control" v-model="termoAD" maxlength="64"
                               v-on:keyup.enter="buscarAD" placeholder="ao menos 3 caracteres" />
                        <div class="input-group-append">
                            <button class="btn btn-sm btn-outline-primary m-0" type="button" :disabled="buscandoAD" @click="buscarAD">
                                <i class="fa fa-search"></i>&nbsp;Buscar
                            </button>
                        </div>
                    </div>
                    <ul class="list-group mt-1 lista-ad" v-if="resultadoAD.length">
                        <li v-for="u in resultadoAD" :key="u.strusuario"
                            class="list-group-item list-group-item-action py-1"
                            :class="{ 'text-muted': u.cadastrado }"
                            @click="!u.cadastrado && escolherAD(u)">
                            <strong>{{u.strusuario}}</strong> — {{u.strnome}}
                            <small>{{u.stremail || '(sem e-mail no AD)'}}</small>
                            <span v-if="u.cadastrado" class="badge badge-secondary ml-1">já cadastrado</span>
                        </li>
                    </ul>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-6">
                    <label for="strnome">Nome<span class="required-label">*</span></label>
                    <input type="text" ref="ref_strnome" id="strnome" class="form-control" v-model="usuario.strnome" maxlength="100" />
                </div>

                <div class="col-sm-12 col-md-6 col-lg-6">
                    <label for="stremail">Email<span class="required-label">*</span></label>
                    <input ref="ref_stremail" type="text" class="form-control" id="stremail" v-model="usuario.stremail" maxlength="100"/>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-4">
                    <label for="strusuario">Usuário<span class="required-label">*</span></label>
                    <input ref="ref_strusuario" type="text" class="form-control" id="strusuario" v-model="usuario.strusuario" maxlength="64"/>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-4">
                    <label for="intperfil_id">Tipo de Usuário<span class="required-label">*</span></label>
                    <select ref="ref_intperfil_id" id="intperfil_id" class="browser-default custom-select" v-model="usuario.intidperfil">
                        <option value="">Selecione</option>
                        <option :value="perfil.administrador">Administrador</option>
                        <option :value="perfil.comissao">Comissão</option>
                        <option :value="perfil.eleitor">Eleitor</option>
                    </select>
                </div>


                <div class="col-sm-12 col-md-4 col-lg-4">
                    <label for="strcelular">Telefone<span class="required-label" v-if="usuario.strorigem == 'local'">*</span></label>
                    <masked-input placeholder-char=" " ref="ref_strcelular"  id="strcelular" class="form-control" v-model="usuario.strcelular" maxlength="12" mask="(11) 11111-1111" />
                </div>

                <template v-if="usuario.strorigem == 'local'">
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <label for="strsenha">Senha (mín. 8 caracteres)<span class="required-label">*</span></label>
                        <input type="password" class="form-control" ref="ref_strsenha" id="strsenha" v-model="usuario.strsenha" maxlength="128" autocomplete="new-password"/>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <label for="strcsenha">Confirmar Senha<span class="required-label">*</span></label>
                        <input type="password" class="form-control" id="strcsenha" v-model="usuario.strcsenha" maxlength="128" autocomplete="new-password"/>
                    </div>
                </template>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button class="btn btn-primary" :disabled='clicked' @click="saveUsuario()"><i class="fa fa-save mr-1 pr-1 "></i> &nbsp; Salvar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as helpers from './../../helpers';
import MaskedInput from 'vue-masked-input'

export default {
  components:{
      MaskedInput
  },
  data() {
    return {
        usuario: {
            intidperfil:'',
            strorigem:'local',
        },
        adHabilitado: false,
        termoAD: '',
        resultadoAD: [],
        buscandoAD: false,
        clicked:false
    };
  },
  computed:{
      perfil () {
         return {
             administrador:process.env.VUE_APP_PERMISSAO_ADMINISTRADOR,
             comissao:process.env.VUE_APP_PERMISSAO_COMISSAO,
             eleitor:process.env.VUE_APP_PERMISSAO_ELEITOR
         }
      }
  },
  mounted() {
    axios.get("login/configuracao").then(res => {
        this.adHabilitado = !!(res.data && res.data.ad);
        if (this.adHabilitado) this.usuario.strorigem = 'ad';
    }).catch(() => {});
  },
  methods: {
    async buscarAD() {
        if (!this.termoAD || this.termoAD.trim().length < 3) {
            toastr.error("Digite ao menos 3 caracteres para buscar no AD");
            return;
        }
        this.buscandoAD = true;
        await axios.get("/usuarios/ad/buscar", { params: { termo: this.termoAD.trim() } })
          .then(res => {
              this.resultadoAD = res.data.usuarios || [];
              if (!this.resultadoAD.length) toastr.info("Nenhuma conta ativa encontrada no AD");
          }, e => toastr.error((e.response && e.response.data && e.response.data.mensagem) || "Falha ao consultar o AD"));
        this.buscandoAD = false;
    },
    escolherAD(u) {
        this.usuario = Object.assign({}, this.usuario, { strusuario: u.strusuario, strnome: u.strnome, stremail: u.stremail });
        this.resultadoAD = [];
        if (!u.stremail) toastr.warning("Esta conta não tem e-mail no AD: informe um e-mail para o comprovante.");
    },
    async saveUsuario() {
        const local = this.usuario.strorigem == 'local';
        if (helpers.isEmpty(this.usuario.strnome)) {
            toastr.error("Nome do usuário é obrigatório");
            this.$refs.ref_strnome.focus();
            return false;
        }
        if (helpers.isEmpty(this.usuario.stremail) || !helpers.isEmail(this.usuario.stremail)) {
            toastr.error("Insira um email válido");
            this.$refs.ref_stremail.focus();
            return false;
        }
        if (helpers.isEmpty(this.usuario.strusuario)) {
          toastr.error("O login do usuário é obrigatório");
          this.$refs.ref_strusuario.focus();
          return false;
        }
        if(local && this.usuario.strusuario.length < 5){
            toastr.error("O login do usuário deve conter no mínimo 5 caracteres");
            this.$refs.ref_strusuario.focus();
            return false;
        }
        if(helpers.isEmpty(this.usuario.intidperfil) || this.usuario.intidperfil ==0) {
            toastr.error("O perfil é obrigatório");
            this.$refs.ref_intperfil_id.focus();
            return false;
        }
        if(local && helpers.isEmpty(this.usuario.strcelular)) {
            toastr.error("O telefone é obrigatório");
            $('#strcelular').focus();
            return false;
        }
        if (local) {
            if (helpers.isEmpty(this.usuario.strsenha) || this.usuario.strsenha.length < 8) {
                toastr.error("A senha deve ter pelo menos 8 caracteres");
                this.$refs.ref_strsenha.focus();
                return false;
            }
            if (this.usuario.strsenha != this.usuario.strcsenha) {
                toastr.error("As senhas não coincidem");
                this.$refs.ref_strsenha.focus();
                return false;
            }
        }
      const dados = Object.assign({}, this.usuario);
      if (!local) { delete dados.strsenha; delete dados.strcsenha; }
      this.clicked = true;
      await axios.post("/usuarios/cadastrar", dados)
      .then(res => {
          toastr.success("Usuário cadastrado com sucesso");
          this.$emit('refreshComponent');
          $(".modal").modal("hide");
        },(e)=>{
          toastr.error(e.response.data.mensagem);
        });
        this.clicked = false;
    }
  }
};
</script>

<style>
.lista-ad {
  max-height: 200px;
  overflow-y: auto;
  cursor: pointer;
  font-size: 10pt;
}
</style>
